module.exports = __webpack_public_path__ + "static/media/background.277a4a79.jpeg";